import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import authHeader from "./authHeader";
import { apiInstance } from "./axiosApi";

export const getAllContest = createAsyncThunk(
  "admin/allContest",
  async ({ page, limit, filter, searchData }, { rejectWithValue }) => {
    try {
      let url = `/contest/all?page=${page}&limit=${limit}`;
      if (filter) {
        url += `&contestFilter=${filter}`;
      }
      if (searchData) {
        url += `&search=${searchData}`;
      }
      const response = await apiInstance.get(url, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getSingleContest = createAsyncThunk(
  "admin/singleContest",
  async (ContestId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`/contest/${ContestId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const addContest = createAsyncThunk(
  "admin/addContest",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/contest/add`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const editContest = createAsyncThunk(
  "admin/editContest",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/contest/edit`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteContest = createAsyncThunk(
  "admin/deleteContest",
  async (selectedId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.delete(
        `/contest/delete/${selectedId}`,
        {
          headers: authHeader(),
        }
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getContestLeaderboard = createAsyncThunk(
  "admin/ContestLeaderboard",
  async ({ContestId}, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`/qa/contest/ranks?contestFilter=${ContestId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  contestLoading: false,
  LeaderboardLoading: true,
};

const contestSlice = createSlice({
  name: "contestSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllContest.fulfilled, (state, action) => {
      state.contestData = action.payload.data;
      state.contestLoading = false;
    });
    builder.addCase(getSingleContest.fulfilled, (state, action) => {
      state.singleContestData = action.payload.data;
    });
    builder.addCase(getContestLeaderboard.fulfilled, (state, action) => {
      state.contestLeaderboardData = action.payload.data;
      state.LeaderboardLoading = false;
    });
  },
});
export default contestSlice.reducer;
